import { string } from 'prop-types';
import React, { useEffect, useState } from 'react'
import { Input } from 'reactstrap'


type propsInputNumber = {
    min?: number,
    max?: number,
    digits?: number,
    className?: string,
    onChange: (e:string,nerrors:number) => void,
    placeholder?:string

}
export default function InputNumber(props: propsInputNumber) {

    const [valueinput, setvalueinput] = useState<string>("");
    const [errorsList, seterrorsList] = useState<string[]>([])
    const [errorComponent, seterrorComponent] = useState<HTMLElement>()
    const ERROR_DIGITOS = "Se esperaban n dígitos"
    const ERROR_MINIMO = "Valor menor a lo esperado";
    const ERROR_MAXIMO = "Valor excede el máximo";
    const ERROR_NUMERO = "Solo puede ingresar numeros";
    const ERRORES = [ERROR_MINIMO, ERROR_MAXIMO,ERROR_NUMERO]

    function auxiliarValidarEliminarError(errorActual:string,propiedadesInput:propsInputNumber):string{
        var texto_error = errorActual;
        if(errorActual === ERROR_MINIMO){
            texto_error += ` (${propiedadesInput.min})` 
        }
        else if (errorActual === ERROR_MAXIMO){
            texto_error += ` (${propiedadesInput.max})` 
        }
        return texto_error
    }

    function ValidateErrores(erroresActuales: string[], erroresAgregar: string[], erroresQuitar:string[], propiedadesInput:propsInputNumber) :string[]{
       
        var listado_final:string[] = [...erroresActuales];

        erroresAgregar.map((errorEncontrado,index) => {
            var texto_error:string = auxiliarValidarEliminarError(errorEncontrado,propiedadesInput);
            if (!listado_final.find((value) => value == texto_error)) {
                listado_final.push(texto_error);
            }
        })
        erroresQuitar.map((erroresEncontrado,index) => {
            var texto_error:string = auxiliarValidarEliminarError(erroresEncontrado,propiedadesInput);
            var indiceError:number = listado_final.findIndex((value) =>  value == texto_error);

            if (indiceError !== -1) {
                var filtered: string[] = listado_final.filter(function (value, index, arr) {
                    return value !== texto_error;
                });
               
                listado_final = filtered
            }
        })

        seterrorsList(listado_final)
        return listado_final

        
    }

    function EliminarError(errores: string[], errorActual: string, propiedadesInput:propsInputNumber) {
        var texto_error:string = auxiliarValidarEliminarError(errorActual,propiedadesInput);

        var indiceError:number = errores.findIndex((value) =>  value == texto_error);
        if (indiceError !== -1) {
            var filtered: string[] = errores.filter(function (value, index, arr) {
                return value !== texto_error;
            });
            seterrorsList(filtered)
        }
    }

    function handleChange(e: string) {

        var numberREX =/^[0-9]*$/;
        var myArray = e.match(numberREX);
        var valor: number = +e;
        var cambiarValor:boolean = true ;
        var erroresAgregar:string[] = [];
        var erroresQuitar:string[] = [];

        if(myArray === null){
            if(props.digits && e.length > props.digits){
                cambiarValor = false
                // return 
            }
            else{
                cambiarValor = false
                erroresAgregar.push(ERROR_NUMERO);
            }   
            
            // ValidateErrores(errorsList, ERROR_NUMERO,props)
            // return

        }
        else if (myArray !== null && cambiarValor) {
            // EliminarError(errorsList,ERROR_NUMERO,props)
            erroresQuitar.push(ERROR_NUMERO);
            if (props.digits) {    
                // if (e.length <=  props.digits) {
                //     // setvalueinput(e)
                //     cambiarValor = true
                // }else{
                //     return
                // }

                cambiarValor = e.length <= props.digits

                if (props.max && cambiarValor) {
                    if (valor > props.max) {
                        erroresAgregar.push(ERROR_MAXIMO)
                        // ValidateErrores(errorsList, ERROR_MAXIMO,props)
                    }
                    else{
                        erroresQuitar.push(ERROR_MAXIMO)

                        // EliminarError(errorsList,ERROR_MAXIMO,props)

                    }
                    // setvalueinput(e)
                }
                if (props.min && cambiarValor && e.length === props.digits) {
                    if (valor < props.min) {
                        erroresAgregar.push(ERROR_MINIMO)
                        // ValidateErrores(errorsList, ERROR_MINIMO,props)
                    }
                    else {
                        erroresQuitar.push(ERROR_MINIMO)

                        // EliminarError(errorsList,ERROR_MINIMO,props)
                    }
                    // setvalueinput(e)
                }
            }
            // else {
            //     if (props.max) {
            //         if (valor > props.max) {
            //             ValidateErrores(errorsList, ERROR_MAXIMO,props)
            //         }
            //         else{
            //             EliminarError(errorsList,ERROR_MAXIMO,props)

            //         }
            //     }
            //     if (props.min) {
            //         if (valor < props.min) {
            //             ValidateErrores(errorsList, ERROR_MINIMO,props)
            //         }
            //         else {
            //             EliminarError(errorsList,ERROR_MINIMO,props)
            //         }
            //     }
            //     setvalueinput(e)
            // }
        }

        var listado_final:string[] = ValidateErrores(errorsList,erroresAgregar,erroresQuitar,props);
        if(cambiarValor){
            props.onChange(e,listado_final.length);
            setvalueinput(e)
        }



        
    }

    useEffect(() => {
        
    }, [valueinput])
    






    useEffect(() => {
        if (errorsList.length > 0) {
            var htmlerrores: any = errorsList.map((val, index) => {
                return (
                    <span key={"error_input_number " + index}>
                        <small className="errorFormat" >
                            {index+1 +".- " + val}
                        </small>
                        <br/>
                    </span>

                )
            })
            seterrorComponent(htmlerrores)
        }
    }, [errorsList])


    return (
        <React.Fragment>
            <Input
                type="text"
                className={props.className}
                value={valueinput}
                onChange={(e) => handleChange(e.target.value)}
                required
                placeholder = {props.placeholder?props.placeholder:undefined} 
            >
            </Input>

            {errorsList.length > 0 &&
                errorComponent
            }
        </React.Fragment>

    )
}
